const config = {
  API_URL: "/backend/api",
};

export default config;